import { Component, OnInit } from '@angular/core';
import { Meta } from '../common/seo.service';
import { FillerService } from '../common/Service_tnFiller';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as myGlobals from '../global';

@Component({
  selector: 'app-news',
  templateUrl: '../themes/default/html/news.component.html',
  styleUrls: ['../themes/default/css/news.component.scss']
})
export class NewsComponent implements OnInit {

  NewsList: any = [];

  constructor(private myMeta: Meta, private filler: FillerService, private activatedRoute: ActivatedRoute) {
    myMeta.setTitle('News');
   }

  ngOnInit() {
    this.UpdateFiller();
  }

  UpdateFiller() {
    var payload = JSON.stringify({id: 0, categoryId: 0, homeVisible: "false", offset: 0, limit: 0, uiCulture: "it"});
    new Promise((resolve, reject) => {
      this.filler.Get_News_List(payload).subscribe(
          data => {
            this.NewsList = Object.assign([], data.Items)
            resolve(true);
          }, err => { console.log(err) }
        );
    }).then(
      e => console.log('')
    );
    
  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/news/news.component.ts